
import { Result } from "../model/Result";
import axiosCilent from "./axiosClient";

const strage = sessionStorage;

const jwtApi = {
  requestGetJwt: async (email: string, authUid: string): Promise<Result> =>  {
    try {
      return await axiosCilent.post(`getJwt`, {email, authUid}).then((resolve) => {
        strage.setItem("jwt", resolve.data.data);
        return resolve.data;
      });
    } catch (error) {
        console.error(error)
        return {success: false, data: error};
    }
  },
};

export default jwtApi;
